import {
    MembershipsState,
    LOAD_MEMBERSHIPS_STARTED,
    LOAD_MEMBERSHIPS_FAILED,
    LOAD_MEMBERSHIPS_SUCCEEDED,
    MembershipsActionTypes,
  } from './types';

  const initialState = {
    globalMemberships: [] as string[],
    loading: false,
    loaded: false,
    failed: false
  };

  const reducer = (
    state: MembershipsState = initialState,
    action: MembershipsActionTypes
  ): MembershipsState => {
    switch (action.type) {
      case LOAD_MEMBERSHIPS_SUCCEEDED: {
        return {
          globalMemberships: action.payload,
          loading: false,
          loaded: true,
          failed: false
        };
      }
      case LOAD_MEMBERSHIPS_STARTED: {
        return {
          ...state,
          loading: true,
          loaded: false,
          failed: false
        };
      }
      default: {
        return state;
      }
    }
  };

  export default reducer;
